import { RegularDealsStoreProvider, useRegularDealsStore } from "~/lib/stores/regular-deals";
import { DealFeed } from "./DealFeed";
import { buildShopChannel } from "~/lib/deal-channel";
import { useFetchOnce } from "~/lib/hooks/useFetchOnce";

interface RecommendedSectionProps {
  categoryId: string;
  tabId: string;
}

function RecommendedSectionContent({ categoryId, tabId }: RecommendedSectionProps) {
  const { deals, isLoading, fetchDeals, fetchMoreDeals, hasMore } = useRegularDealsStore();

  const channelString = JSON.stringify(buildShopChannel(tabId));

  useFetchOnce(
    deals.length === 0 ? `${categoryId}|${tabId}` : null,
    () => {
      const channel = buildShopChannel(tabId);
      fetchDeals(categoryId, undefined, channel);
    },
    !isLoading
  );

  const handleLoadMore = () => {
    if (hasMore && !isLoading) {
      const channel = buildShopChannel(tabId);
      fetchMoreDeals(channel);
    }
  };

  return (
    <section>
      <div className="mb-[16px] flex items-center justify-between">
        <h2 className="text-[24px] leading-[34px] font-bold">Recommended for you</h2>
      </div>
      <DealFeed
        deals={deals}
        onLoadMore={handleLoadMore}
        isLoading={isLoading}
        hasMore={hasMore}
        dealPerRow={{
          default: 2,
          mobile: 2,
          tablet: 3,
          desktopSmall: 4,
          desktopLarge: 5,
        }}
        channel={channelString}
      />
    </section>
  );
}

export default function RecommendedSection(props: RecommendedSectionProps) {
  return (
    <RegularDealsStoreProvider channelId={props.categoryId}>
      <RecommendedSectionContent {...props} />
    </RegularDealsStoreProvider>
  );
}
